export default __webpack_public_path__ + "static/moreStorage-34f2450b7bad5166bbf0de3b2ac11c63.mp4";